import * as React from "react";
const SvgFiRrCardClub = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M15.956 13.428a1.998 1.998 0 0 1-3.358.996c.197.66.454 1.284.802 1.825.209.325-.046.752-.432.752h-1.935c-.386 0-.641-.427-.432-.752.348-.541.606-1.165.802-1.825a1.998 1.998 0 0 1-3.358-.996A2.002 2.002 0 0 1 10.001 11c.101 0 .197.015.293.03a2 2 0 0 1-.293-1.03 2 2 0 1 1 4 0c0 .378-.111.728-.293 1.03.097-.014.193-.03.293-.03a2.002 2.002 0 0 1 1.955 2.428M21 5v14c0 2.757-2.243 5-5 5H8c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h8c2.757 0 5 2.243 5 5m-2 0c0-1.654-1.346-3-3-3H8C6.346 2 5 3.346 5 5v14c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3z"
    />
  </svg>
);
export default SvgFiRrCardClub;
